export default __webpack_public_path__ + "static/media/Bg.f86ffb73.webp";